import { request } from '@/utils/request';
import { query } from 'src/utils/request';
export const getCompanyInfo = (params?:any) => {
  return query('/zlb/api/expense/apply-form/default-info', {
    params,
  });
};
// 保存申会议签到
export const saveMeetingSign =  (data) => {
  return request('/zlb/api/expense/meeting-sign/save', {
    method: 'POST', data
  });
};

export const reqApplyDetail = async (params) => {
  return query('/zlb/api/expense/apply-form/query', {
    params,
  });
};

// 单位信息查询
export const reqCompanyInfo = async (params) => {
  return query('/zlb/api/expense/apply-form/default-info', { 
    params,
  });
};

export const getMeetingSignDataList = (data) => {
  return query('/zlb/api/expense/meeting-sign/page', {
    method: 'POST', data
  });
};

// 查询申请单列表
export const getApplyFormList = async (data) => {
  return query('/zlb/api/expense/meeting-sign/apply-from', {
    method: 'POST', 
    data,
  });
};

/**
 * 删除会议签到表
 * @param signFormCode 
 * @returns 
 */
export const deleteMeetingSign = (signFormCode:string) => {
  return request(`/zlb/api/expense/meeting-sign/delete/${signFormCode}`,{
    method: 'DELETE',
  });
};

export const publishMeetingSign = (data) => {
  return request('/zlb/api/expense/meeting-sign/release',{
    method: 'POST', data
  });
};

// 作废
export const nullifyMeetingSign = (signFormCode:string) => {
  return request(`/zlb/api/expense/meeting-sign/nullify/${signFormCode}`,{
    method: 'POST',
  })
};

export const getMeetingSignDetail = (data) => {
  return request('/zlb/api/expense/meeting-sign/queryOne',{ params:data });
}
// 结束签到wswaq
export const stopMeetingSign = (data) => {
  return request('/zlb/api/expense/meeting-sign/stop',{
    method: 'POST', data
  });
};

export const getQrCodeStr = (signFormCode:string) => {
  return request(`/zlb/api/expense/meeting-sign/getSignKey/${signFormCode}`);
};
// 补签
export const signHandSave = (data) => {
  return request('/zlb/api/expense/meeting-sign/signHandSave',{
    method: 'POST', data
  });
};
export const getAgendaDetail = (params) => {
  return request('/zlb/api/expense/meeting-sign/queryAgendaPersonList',{ params });
};

export const delAgendaUser = (signPersonCode:string) => {
  return request(`/zlb/api/expense/meeting-sign/deleteSignPerson/${signPersonCode}`,{
    method: 'DELETE'
  });
};

export const getAgendaUserDetail = (signPersonCode: string) => {
  return request(`/zlb/api/expense/meeting-sign/getSignPerson/${signPersonCode}`);
};
/**
 * 下载会议签到表
 * @param params
 * @returns 
 */
export const downloadMeetingList = (params) => {
  return request('/zlb/api/expense/meeting-sign/print',{ params });
};
// /**
//  * 下载议程签到表
//  * @param params
//  * @returns 
//  */
//  export const downloadAgenda = (params) => {
//   return request(`/zlb/api/expense/meeting-sign/print`,{ params });
// }

// 获取登陆人信息
export const getOperatorInfo = async () => {
  return request('/api/user/current/operator/displayInfo');
};

// 获取指定人员信息
export const getDesignateInfo = async (data) => {
  return request('/zlb/api/expense/meeting-sign/designated-list', {
    method: 'POST', data
  });
};

// 指定人员信息
export const saveDesignated = async (data) => {
  return request('/zlb/api/expense/meeting-sign/designated', {
    method: 'POST', data
  });
};

export const getSignPerson = async (data) => {
  return request('/zlb/api/expense/meeting-sign/getSignPerson', {
    method: 'POST', data
  });
};